export default {
    nav: {
      home: 'Home',
      service: 'Services',
      case: 'Cases',
      partner: 'Partners',
      contact: 'Contact Us',

    },
    home: {
        bannerTitle: 'Exhibition/Event/Performance stage',
        bannerSubTitle: 'Consultancy for complex temporary',
        bannerInfo: 'Three full-time Tongji civil engineers with National Class-1 structural Engineer Certification',
        bannerSubInfo: '11 years of experience in temporary structural engineering for domestic and international exhibitions',
        bannerDetail: `BELIEVE is one of the few construction engineering consulting companies in China that specializes in temporary structures for exhibitions, large-scale events and stage performances. The founding team of the company includes one full-time PhD, one full-time master's degree, and one full-time bachelor's degree from the Civil Engineering School of Tongji University. There are also two full-time Chinese National Class 1 Registered Structural Engineers and one Chinese National Registered Civil Engineer.`,
        bannerSubDetail: 'The founding team has 11 years of experience in providing services throughout the entire process, from early scheme consultation, drawing design, site approval to production, installation, and safety supervision. They have established long-term stable cooperation with many top domestic and foreign event companies, public relations companies, creative design companies, exhibition companies, AV companies, structural factories, exhibition halls, and shopping malls.',
        xu: {
            name: 'Tyler XU',
            info: 'Ph.D. Tongji University',
            subInfo: 'Registered Civil Engineer (Geotechnical)',
            detail1: `12 years' study background in civil engineering in Tongji University（from undergraduate to Ph.D.）.`,
            detail2: `11 years' experience in designing, manufacturing and on site installation of customized steel structures in Shanghai/Beijing international auto show and various large-scale events.`,
            detail3: `9 years' experience in R&D, design, production and site installation of aluminum alloy truss structure for Shanghai/Beijing/Chengdu/Guangzhou International Auto Show and various performances and commercial activities.`,
            detail4: `5 years' production management experience in self-operated structure factory (Prongrand), with in-depth understanding and research on upstream and downstream industrial chain/structural design technology/factory production /on-site installation technology/major domestic venues and activity venues.`,
        },
        chou: {
            name: 'Kevin Chou',
            info: 'Bachelor Tongji University',
            subInfo: 'National Class-1 structural Engineer',
            detail1: `Graduated from Tongji University with a major in Civil Engineering, currently serving as the Chief Engineer at Shanghai  Prongrand.`,
            detail2: `Since 2019, responsible for pre-construction structural design and on-site safety consulting work for events including Shanghai/Beijing/Guangzhou/Chengdu Auto Shows, Shanghai International Expo, and the 2019 Guangzhou Volkswagen Brand Night.`,
            detail3: 'Skilled in structural design, calculation, and safety review for various indoor and outdoor advertising events, such as the 2022 Hainan Riyue Square Duty-Free Shop Armani booth, Dior Water Pop-up in Addison Sanya Hotel , and Dior Star on the water in Sanya.',
            detail4: `Served as on-site structural safety consultant for over hundreds events.`,
            detail5: `Familiar with common structural forms such as reinforced concrete frames, reinforced concrete shear walls, reinforced concrete core tube frames, steel frame structures, reinforced concrete core tube steel frame structures, and portal steel structures, providing structural consulting services for existing buildings.`
        },
        lee: {
            name: 'Lully LEE',
            info: 'Master Graduated from Tongji University',
            subInfo: 'National Class-1 structural Engineer',
            detail1: `Have a background in Structural Engineering from Tongji University for 7years. Completed undergraduate studies in the Department of Building Engineering and focused on the theory and construction technology of steel structures during graduate studies.`,
            detail2: 'Provide structural consulting services for Shanghai/Guangzhou Auto Shows, such as heavy truss calculation and analysis for the BMW booth at the 2023 Shanghai International  Auto Show, and truss construction calculation and design for the Porsche booth.',
            detail3: 'Provide structural design, optimization, and calculation analysis services for large-scale complex outdoor/indoor activities.',
            detail4: 'Skilled in complex spatial structure modeling, design calculation, wind resistance and overall stability analysis.',
            detail5: 'With over 10 years of structural consulting experience,proficient in the design, calculation analysis, monitoring, and structural evaluation of various traditional structural forms, such as frame, frame-shear, frame-tube structures, spatial trusses, grid-shell structures, and large-span spatial grid structures.',
        }
    },
    service: {
        list: [
            {
                title: 'Consultation on Complex Structural',
                content: 'Structural concept design, structural feasibility demonstration, project technical bidding consulting services.',
                case: 'Case: Meeting New Volkswagen in Guangzhou (2019), Dior Water Pop-up in Addison Sanya Hotel (2022), League of Legends World Championship S10 (2020), VIVO Outdoor Event (2023), Autumn and Winter Decoration  of Chengdu Sino-Ocean Taikoo Li (2022)',
                images: [
                    'service_1-1.png',
                    'service_1-2.png',
                    'service_1-3.png',
                    'service_1-4.png',
                ]
            },
            {
                title: 'Structural Design and Safety Review',
                content: 'The detailed design of structure, construction drawing design, structural calculation report and safety suggestions which will be stamped and reviewed by the National Class A Design Institute and the National Class A Registered Structural Engineer.',
                case: `Case: 6 booths (Lincoln, Jaguar Land Rover, Infiniti, Nissan, etc.) at the 2019 Shanghai International Auto Show, 8 booths (Lincoln, Ford, Porsche, Maserati, etc.) at the 2020 Beijing International Auto Show, 9 booths (Porsche, Ford, Honda, Lincoln, Jaguar Land Rover, Janice, etc.) at the 2021 Shanghai International Auto Show, 7 booths (DOW, Thermo, Snow Show, Shanghai Pavilion, etc.)at 2021 Shanghai International Import Expo; 18 booths (BMW, MINI, RR, Porsche, Audi, Jaguar Land Rover, Maserati, Yangwang, POLESTAR, Lamborghini, Nissan, Hyundai, etc) at 2023 Shanghai International Auto Show.`,
                images: [
                    'service_2-1.png',
                    'service_2-2.png',
                    'service_2-3.png',
                    'service_2-4.png',
                ]
            },
            {
                title: 'Structural Safety Supervision on Site',
                content: 'The national class A registered structural engineer and supervision engineer participate in the whole process of factory production, trial construction, on-site structure construction and installation, and practically provide a layer of guarantee for structural safety from the theoretical design to the actual process.',
                case: `Case: SAIC Volkswagen stand in Shenzhen Auto Show(2020),SAIC Volkswagen stand in Chengdu Auto Show(2020), SAIC Volkswagen stand in Shanghai Auto Show(2021), all the stands built in Hall 3, Hall 2 in CIIE （2021、2022）`,
                images: [
                    'service_3-1.png',
                    'service_3-2.png',
                    'service_3-3.png',
                    'service_3-4.png',
                ]
            },
            {
                title: 'Structural Monitoring, Testing, and Stage Inspection Services',
                content: 'We use modern monitoring components, instruments and equipment to monitor and test the actual state of the structure, and we provide testing services for stage structure, cooperating with the third party.',
                case: `Case: Huahai Beauty Carnival Concert stand (2021), SOKEL Winter Decoration in Sino-Ocean Taikoo Li Chengdu (2021), TF stand in Shanghai Xintiandi (2021), Cindy Chao Jewelry Exhibition in Shanghai (2021)`,
                images: [
                    'service_4-1.png',
                    'service_4-2.png',
                    'service_4-3.png',
                    'service_4-4.png',
                ]
            },
            {
                title: 'Site approval service',
                content: 'In addition to structural calculation sheets, structural calculation reports, and structural drawings, we can also provide customers with one-stop agency technical services related to site approval, such as power consumption inspection and overall safety acceptance.',
                case: `Case: Ant Financial Conference stand in Shanghai(2020)`,
                images: [
                    'service_5-1.png',
                    'service_5-2.png',
                    'service_5-3.png',
                    'service_5-4.png',
                ]
            }
        ]
    },
    case: {
        more: 'more',
        list: [
            {
                key: '1',
                title: 'Dior Water Pop-up in Addison Sanya Hotel (2022)',
                desc: 'In one week, a circular island style steel structure POP-UP, a floating ribbon and a pearl on the sea, will be built by "filling the sea" in the non pumped swimming pool, with a depth of two meters, in the Five Star Hotel by the seaside in Sanya',
                content: `We consider these works:
                structural typhoon resistance design, swimming pool base protection design, structural component disassembly and assembly design, structural component handling, water surface positioning and setting out, underwater cement column pier handling and installation, underwater steel structure lifting and installation, temporary lifting gantry installation on water…`,
                image: 'case_1.jpeg',
                detail: [
                    {
                        type: 'text',
                        content: `这个项目是2022年5月份在三亚艾迪逊酒店泳池里搭建的一个直径10m，高约3.3m的一个圆形的快闪店。所有的环形步道（直径18m）、弧形连桥、圆形房子均是新建在水深2m且不抽水的泳池之上，泳池距离海边不足200m，泳池的水系与海水相连通，有很强的腐蚀性，所以这套结构除了没有海浪侵袭之外，其他方面很接近于海上建筑。`,
                    },
                    {
                        type: 'image',
                        content: 'case_1_1.png',
                    },
                    {
                        type: 'text',
                        content: `为保护泳池池底，酒店方要求新搭建的建筑对池底的压力不能超过10kN/m2。为抵御13级台风，结构需要有足够的配重；而为了保护泳池池底，结构的自重又不能过重。为此结构工程师需要在结构抵御台风与保护泳池池底之间作出精细的平衡。
                        此外，由于泳池距离酒店的卸货通道有近200米，几乎所有的搬运车辆、施工机械、吊装设备都无法靠近泳池，水上不允许有焊接作业，所有的结构构件及基础构件均需要靠人力在水上进行拼接，且水池是不抽水作业的。而该项目给到现场的运输搭建时间仅仅为7个白天。为此，结构工程师需要综合考虑结构总体安全、结构构件搬运、结构构件水上定位、水下基础拼装组装、水上钢梁吊装拼装、临时施工步道等因素，帮助客户克服现场存在的诸多困难，在7天内将创意落地变成现实。
                        水上的测量和定位是第一步，需要避开恶劣风浪天气，保证应有的精度，否则为后面水上环形钢梁的拼接带来困难。`
                    },
                    {
                        type: 'image',
                        content: 'case_1_2.jpeg',
                        desc: '',
                    },
                    {
                        type: 'image',
                        content: 'case_1_3.png',
                        desc: '水上测量及定位'
                    },
                    {
                        type: 'text',
                        content: '为减小陆地人工搬运以及水上搬运的难度，我们将结构基础拆分成了198块定制的梯形混凝土块，使得每块的重量不超过260kg，同时在水泥块上设计了搬运和吊装预埋件，同时钢梁也需设计成单件重量不超过200kg的构件。'
                    },
                    {
                        type: 'image',
                        content: 'case_1_4.png',
                    },
                    {
                        type: 'image',
                        content: 'case_1_5.png',
                    },
                    {
                        type: 'text',
                        content: '为减小陆地人工搬运以及水上搬运的难度，我们将结构基础拆分成了198块定制的梯形混凝土块，使得每块的重量不超过260kg，同时在水泥块上设计了搬运和吊装预埋件，同时钢梁也需设计成单件重量不超过200kg的构件。'
                    },
                    {
                        type: 'image',
                        content: 'case_1_6.png',
                    },
                    {
                        type: 'text',
                        content: '为了方便水上搬运、吊装和施工，还专门设计了一套临时施工平台以及truss架龙门结构，为基础水泥块、钢结构、房间大玻璃的吊装提供条件。'
                    },
                    {
                        type: 'image',
                        content: 'case_1_7.png',
                    },
                    {
                        type: 'image',
                        content: 'case_1_8.jpeg',
                    },
                    {
                        type: 'text',
                        content: '上海佰里参与了上述全过程的结构方案设计、施工方案设计、现场结构搭建安全监理等工作。'
                    },
                ]
            },
            {
                key: '2',
                title: 'Dior Star on the water(2021)',
                desc: 'This project is a continuation of the Pop-up retail in the swimming pool of Addison Hotel. The water Pop-up retail will be partially removed, leaving the underwater foundation platform, and a new rotatable star shaped decoration will be built on it. The completed renderings are as follows',
                content: 'The star shaped decoration is a single column structure that needs to resist a Category 13 typhoon and maintain stability under rotating conditions; The new structure needs to be built on the original underwater foundation platform, and how to connect with the original structure shall be considered.',
                image: 'case_2.jpeg',
                detail: [
                    {
                        type: 'text',
                        content: '此项目为迪奥水上快闪店的接续项目，由于快闪店设计的时候已经充分考虑了接续项目的可能性，因此原水下基础平台又被利用了起来。星型装饰主结构为一个单立柱，迎风面为集中在顶端，设防风级为13级台风。通过多次试算，我们选择了底部直径377mm，壁厚6mm圆管，上部减小为直径219mm，壁厚6mm，粗细立柱连接部分采用法兰盘螺栓连接，保证了刚性连接的需求。中部焊接铁板圆球，外圈焊接加强铁板，连接菱形尖角。内部结构图纸见下图：',
                    },
                    {
                        type: 'image',
                        content: 'case_2_1.png'
                    },
                    {
                        type: 'text',
                        content: '立柱底部需要保证刚性连接，我们采用了大铁板底座1.6x1.6x0.02m，大铁板的自重可增强底座稳定性的同时，也增加了与地台铁架的接触面积，设置了共16颗高强螺栓固定，使底座牢牢固定在基础地台之上。配合底座旋转需求，电机的设置，我们设计了两套铁架，上下叠置，下部铁架与原水下基础平台连接，上部铁架地台铁架。底部图纸如下图：'
                    },
                    {
                        type: 'image',
                        content: 'case_2_2.png'
                    },
                    {
                        type: 'text',
                        content: '外圈上人平台的设计，将承重点全部落在了原水下平台基础柱墩点上，很好的利用了原基础，实现了水上结构的转换。基础平面如下图所示：',
                    },
                    {
                        type: 'image',
                        content: 'case_2_3.png',
                    }
                ]
            },
            {
                key: '3',
                title: 'SOKEL Winter Decoration(2022)',
                desc: 'The project is located on Sino-Ocean Taikoo Li Square. In Chengdu .Chengdu has less snow in winter, and this project features a undulating top surface with snow accumulation. The lower part of the snow top is decorated with explosive snowballs, creating a charming effect and coming out to be a popular check-in point in Chengdu. The design renderings (top) and shooting reality images (bottom) are shown in the following figure:',
                content: `The press conference covers an area of approximately 5000 square meters and is located at the Guangzhou Media Port under the Guangzhou Tower. Located under the Guangzhou Tower, with a busy flow of people, the brand is very satisfied with the effect of advertising the event in conjunction with the Guangzhou Tower.`,
                image: ['case_3.1.png', 'case_3.2.jpeg'],
                detail: [
                    {
                        type: 'text',
                        content: `项目位于成都太古里商场，装饰效果非常不错。但对结构设计来说是个挑战。
                        异形顶棚的设计，选定了厚度400mm的双层铁架，沿波浪造型做异形面。反复调整柱位，达到柱位最少的目的。柱间无梁，为增强结构的抗水平风力，在柱底设置了100mm高工字钢地梁，将各个立柱连接为一个整体。
                        针对造型复杂的问题，我们先运用三维软件，根据三维图里的表皮样条线，一块块描出三维线条，该结构的三维线条图如下：
                        `,
                    },
                    {
                        type: 'image',
                        content: 'case_3_1.png'
                    },
                    {
                        type: 'text',
                        content: '将该线条文件导入结构计算软件，建立了如下图的结构验算模型：'
                    },
                    {
                        type: 'image',
                        content: 'case_3_2.png',
                    },
                    {
                        type: 'text',
                        content: `针对风荷载敏感的问题，按照《建筑结构荷载规范》，同时考虑水平向风压和顶棚风吸，确保风载不漏以及准确。
                        柱顶节点进行了两种节点的比选，一个是参照混凝土结构无梁楼板的设计，柱顶设大铁板（柱帽），铁架下弦杆与铁板螺栓对穿，一个是铁架高度范围内设圆套筒，套在立柱上，并用高强螺栓对穿。最终选定了第二种节点做法，实拍图片如下：
                        `
                    },
                    {
                        type: 'image',
                        content: 'case_3_3.png',
                    },
                    {
                        type: 'text',
                        content: '该节点的优势是：1、柱顶节点刚度更强；2、施工更方便；3、避免了柱顶铁架的应力集中。过程中我们不断优化，找到了结构设计合理与造型需求的结合点，完美实现了效果设计意图。'
                    }
                ]
            },
            {
                key: '4',
                title: 'Meeting New Volkswagen in Guangzhou (2019)',
                desc: 'The press conference covers an area of approximately 5000 square meters and is located at the Guangzhou Media Port under the Guangzhou Tower. Located under the Guangzhou Tower, with a busy flow of people, the brand is very satisfied with the effect of advertising the event in conjunction with the Guangzhou Tower.',
                content: `The structure has just been completed, and this press conference is located on the top plate of the frame. The original design party of the roof only provided a rough usage requirement of 3.5t/m2 for the fire lane and 500kg/m2 outside the fire lane. This roof is firstly used for this activity .The tent that needs to be built for the activity has a maximum single column with a total weight of 7.5t on the bottom. Can it be safely loaded? During the construction process, it is necessary to walk a crane with a maximum self weight of 13t outside the fire lane. Can it safely bear the load?`,
                image: 'case_4.jpeg',
                detail: [
                    {
                        type: 'text',
                        content: `顶板承重的问题，首先需要了解原顶板的设计。我们首先配合主办方找到广州电视台的基建部门，要到了一套完成的建筑和结构两个专业的设计图纸。同时，我们搜集了活动需要使用的各个使用功能以及搭建物的重量，请各专业分包商提供出了如下重量分布表：`,
                    },
                    {
                        type: 'image',
                        content: 'case_4_1.png',
                    },
                    {
                        type: 'image',
                        content: 'case_4_2.png',
                    },
                    {
                        type: 'text',
                        content: `为保证活动顺利以及结构的安全，我们制定了重量使用的如下原则：保证必须的重量，减去不必要的重量，预留尽量多的重量。
                        例如我们发现，篷房的立柱单点重量之所以非常大，除了篷房自重以及天花内灯光truss及灯光设备的重量外，有3t的重量来自于对篷房柱脚的水泥块配重。我们检查了该篷房的计算书，该配重的风载设防标准为上海地区50年一遇基本风压0.55kPa，而广州地区10年一遇基本风压仅为0.3kPa（活动持续时间10天，按临时结构考虑），不需要如此多的配重。尽管我们对此项进行了专业的分析及计算，但篷房分包方（某外资）坚持需要3t的配重。我们需要重新寻找方法，替代这个3t的重量。
                        我们对图纸进行了深度学习，了解到该结构顶板的详细做法如下表：
                        `,
                    },
                    {
                        type: 'image',
                        content: 'case_4_3.png',
                    },
                    {
                        type: 'text',
                        content: `我们想到可以在柱底用抗拉锚栓打入建筑面层，只要控制锚栓深度不大于150mm，就不会破坏原顶板建筑防水层。在施工前，篷房分包方按照我们的方案进行了现场锚栓抗拔试验，18处柱脚中，只有3处柱脚锚栓不满足3t的抗拔要求（柱脚锚板被拉坏，面层破坏，分析原因为该处面层内积水，C20的混凝土强度不达标），该方案得以最终实施，减少了不必要的重量。
                        针对施工过程中需要走行自重13t的吊车问题，我们通过等效均布荷载的方法，理论验证了吊车走行的等效均布荷载小于500kg/m2的限值要求。同时在现场利用灭火器标注出顶板上各个楼下混凝土立柱的位置，限值吊车跨柱走行，使得重量分担在两个不同的柱跨内，进一步提升了我们的施工安全系数。
                        活动设施搭建期间，我们建立了顶板安全巡视制度，每日巡查顶板下楼板情况，形成了每日报告。
                        `,
                    },
                    {
                        type: 'image',
                        content: 'case_4_4.jpeg',
                    },
                    {
                        type: 'text',
                        content: `我们挑选了几个特定进度节点，对柱跨跨中进行沉降观测，并形成了水准测量报告。`,
                    },
                    {
                        type: 'image',
                        content: 'case_4_5.png',
                    },
                    {
                        type: 'text',
                        content: `以上两项工作，均证实了楼板正在安全承重。
                        后期，在活动进行期间，以及结束后撤场期间，应主办要求，我们均负责了场地的安全巡视、监测工作。
                        `,
                    },
                ]
            },
        ]
    },
    partner: {

    },
    contact: {
        title: 'Business Contact:',
        email: 'E-mail:',
        wechat: 'Wechat:',
        redbook: 'Redbook:',
        tiktok: 'TikToK:',
        phone: 'Phone:',
        address: 'Adress:'
    }
  }

